import * as React from "react";
import { forwardRef } from "react";
const ArrowUpSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { fillRule: "evenodd", d: "M3.336 12.747a1 1 0 0 1-.083-1.411l8-9a1 1 0 0 1 1.494 0l8 9a1 1 0 0 1-1.494 1.328L12 4.505l-7.253 8.16a1 1 0 0 1-1.411.082", clipRule: "evenodd" }),
    React.createElement("path", { fillRule: "evenodd", d: "M12 22a1 1 0 0 1-1-1V4a1 1 0 1 1 2 0v17a1 1 0 0 1-1 1", clipRule: "evenodd" }));
const ForwardRef = forwardRef(ArrowUpSVG);
export default ForwardRef;
//# sourceMappingURL=ArrowUp.js.map